import { render } from "./VvListStoredObjectInput.vue?vue&type=template&id=232b14d3"
import script from "./VvListStoredObjectInput.vue?vue&type=script&lang=js"
export * from "./VvListStoredObjectInput.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__